<template>
  <Card
    :dt="{
      body: {
        padding: '0px !important',
      },
    }"
  >
    <template #header>
      <div class="flex bg-gray-100 dark:bg-gray-800 p-1 rounded-t-md">
        <Tabs value="front" class="w-full">
          <TabList class="p-0 w-full tab-list">
            <Tab v-for="photoType in photoTypes" :key="photoType" :value="photoType">
              {{ $t(`messages.detail.photos.${photoType}`) }}
            </Tab>
          </TabList>
          <TabPanels class="p-0 w-full bg-gray-100 dark:bg-gray-800">
            <TabPanel v-for="photoType in photoTypes" :key="photoType" :value="photoType">
              <PhotoUploadComponent :photoType="photoType" :objectId="objectId" />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { readonly } from 'vue'
import PhotoUploadComponent from '../../PhotoUploadComponent.vue'

const props = defineProps({
  objectId: { type: [String, Number], default: '' },
})

const photoTypes = readonly(['front', 'indoor', 'outdoor'])
</script>

<style scoped>
  .tab-list {
    --p-tabs-tablist-background: var(--primary-color);
  }
</style>
